/* eslint-disable no-console */
import { Button, Modal, TextControl } from "@wordpress/components";
import { useState, useMemo } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { produce } from "immer";

import Options from "./Options";
import Preview from "./Preview";

// import { useWPAjaxMutation } from "./../../../../wp-utils/v1/hooks";

import "./style.scss";
import { useEffect } from "@wordpress/element";
import presetSchema from "./presetSchema.json";
// import {  } from "../../../wp-utils/v1";
import { useWPAjaxMutation, useWPAjaxQuery } from "../../../../wp-utils/v1";

const Preset = ({ attributes, setAttributes }) => {
  const { uniqueId, presetOpened, presetData, editingPresetID, presets: myPresets } = attributes;
  const [isPremium, setIsPremium] = useState(ytpPlayer.is_premium);
  const {
    saveData,
    data,
    isLoading: isSaving,
  } = useWPAjaxMutation(ytpPlayer?.ajaxURL, { nonce: ytpPlayer?.nonce, method: "createOrUpdate", action: "ytp_ajax", model: "Presets" });
  const { data: presets, isLoading } = useWPAjaxQuery(ytpPlayer?.ajaxURL, { nonce: ytpPlayer?.nonce, method: "fetchPresets", action: "ytp_ajax", model: "Presets" });
  const [notice, setNotice] = useState({});
  const [preset, setPreset] = useState({});

  const schema = useMemo(() => {
    const schema = {};
    Object.keys(presetSchema).map((key) => {
      schema[key] = presetSchema[key]?.default;
    });
    return schema;
  }, []);

  useEffect(() => {
    if (!isLoading) {
      setAttributes({ presets });
    }
  }, [isLoading]);

  useEffect(() => {
    const presetData = myPresets?.find((item) => item.id == editingPresetID) || { preset: schema };
    setPreset(presetData);
  }, [editingPresetID]);

  const updatePreset = (option) => {
    const key = Object.keys(option)?.[0];
    if (key) {
      const newPreset = produce(preset, (draft) => {
        draft.preset[key] = option[key];
      });
      setPreset(newPreset);
    }
  };

  const handleCreatePreset = async () => {
    setNotice({});
    if (!preset.name) {
      return setNotice({ type: "error", message: "Name field is required" });
    }
    try {
      const response = await saveData(preset);
      if (response) {
        if (myPresets.find((item) => item?.id === preset.id)) {
          const newPresets = produce(myPresets, (draft) => {
            const index = draft.findIndex((item) => item.id === preset.id);
            draft.splice(index, 1, preset);
          });
          setAttributes({ presets: newPresets });
        } else {
          setAttributes({ presets: [...myPresets, { ...preset, id: response }], editingPresetID: response });
        }
        setNotice({ type: "success", message: "Success" });
      }
    } catch (error) {
      setNotice({ type: "error", message: "Failed" });
    }
  };

  return (
    <>
      {presetOpened && (
        <Modal title={__("Preset", "ytp")} onRequestClose={() => setAttributes({ presetOpened: false })} className="ytpPresetModal" shouldCloseOnClickOutside={false}>
          <TextControl value={preset.name || ""} onChange={(name) => setPreset({ ...preset, name })} />
          <div className="ytpPreset">
            <div className="options">
              <Options isPremium={isPremium} setPreset={updatePreset} preset={preset} />
            </div>
            <div className="preview">
              <Preview isPreset={true} uniqueId={uniqueId} preset={preset} />
            </div>
          </div>

          <div className="actionsWrapper">
            <div className="actions">
              <div></div>
              <div>
                {notice?.message && <span className={`notice ${notice.type}`}>{notice.message}</span>}
                {isSaving && <div class="ytp_loader"></div>}
                <Button disabled={isSaving} variant="primary" onClick={handleCreatePreset}>
                  {preset?.id ? __("Update", "ytp") : __("Create", "ytp")}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Preset;
